<div class="notification-bell-container" [class.disabled]="isOnNotificationsPage">
  <button class="notification-bell-button"
    [matMenuTriggerFor]="isOnNotificationsPage ? null : notificationMenu"
    (menuOpened)="onMenuOpened()"
    (click)="onDisabledBellClick()"
    [class.shake]="hasNewNotification"
    [matTooltip]="isOnNotificationsPage ? ('notifications.bell.disabledTooltip' | translate) : ''"
    matTooltipPosition="below" aria-label="Notificaciones">
    <svg class="bell-icon" width="24" height="24" viewBox="0 0 24 24" fill="currentColor"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 2C10.3431 2 9 3.34315 9 5V5.56907C7.03196 6.56679 5.5 8.58481 5.5 11V16.5L3 19V20H21V19L18.5 16.5V11C18.5 8.58481 16.968 6.56679 15 5.56907V5C15 3.34315 13.6569 2 12 2Z" />
      <path d="M10.5 21C10.5 22.3807 11.6193 23.5 13 23.5C14.3807 23.5 15.5 22.3807 15.5 21H10.5Z" />
    </svg>

    <span class="notification-badge" *ngIf="(unreadCount$ | async) as count" [class.pulse]="hasNewNotification">
      {{ count > 99 ? '99+' : count }}
    </span>

    <span class="connection-indicator"
      [class.connected]="connectionState === 'connected'"
      [class.connecting]="connectionState === 'connecting' || connectionState === 'reconnecting'"
      [class.disconnected]="connectionState === 'disconnected' || connectionState === 'failed'"
      [matTooltip]="getConnectionTooltip()"
      matTooltipPosition="below">
    </span>
  </button>

  <div class="notification-toast" *ngIf="toastNotification" [@toastAnimation]>
    <div class="toast-content" (click)="onToastClick()">
      <div class="toast-icon">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
          <path d="M12 2C10.3431 2 9 3.34315 9 5V5.56907C7.03196 6.56679 5.5 8.58481 5.5 11V16.5L3 19V20H21V19L18.5 16.5V11C18.5 8.58481 16.968 6.56679 15 5.56907V5C15 3.34315 13.6569 2 12 2Z" />
        </svg>
      </div>
      <div class="toast-text">
        <span class="toast-title">{{ toastNotification.title }}</span>
        <span class="toast-message" *ngIf="toastNotification.message">{{ toastNotification.message }}</span>
      </div>
      <button class="toast-close" (click)="dismissToast($event)" [attr.aria-label]="'notifications.detail.close' | translate">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path d="M12 4L4 12M4 4L12 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
        </svg>
      </button>
    </div>
  </div>

  <mat-menu #notificationMenu="matMenu" class="notification-menu" xPosition="before">
    <div class="notification-dropdown" (click)="$event.stopPropagation()">
      <div class="dropdown-header">
        <div class="header-row-top">
          <h2 class="dropdown-title">{{ 'notifications.title' | translate }}</h2>
          <div class="unread-toggle">
            <label class="toggle-switch">
              <input type="checkbox" [checked]="showOnlyUnread" (change)="toggleUnreadFilter()"
                [attr.aria-label]="'notifications.panel.filterUnread' | translate" />
              <span class="slider"></span>
              <span class="toggle-label">{{ 'notifications.panel.unreadOnly' | translate }}</span>
            </label>
          </div>
        </div>

        <div class="header-row-actions">
          <button class="action-button-text mark-all-read" (click)="markAllAsRead()"
            [title]="'notifications.markAllAsRead' | translate" *ngIf="(unreadCount$ | async) as unreadCount">
            {{ 'notifications.markAllAsRead' | translate }}
          </button>

          <button class="action-button-text create-task-header" (click)="openCreateTask()"
            [title]="'myTasks.create_task.title' | translate"
            [attr.aria-label]="'myTasks.create_task.title' | translate">
            {{ 'myTasks.create_task.title' | translate }}
          </button>
        </div>
      </div>

      <div class="dropdown-tabs">
        <button class="tab-button tasks" [class.active]="activeTab === 'tareas'" (click)="setActiveTab('tareas')">
          {{ 'notifications.tabs.tasks' | translate }}
        </button>
        <!-- todo: review requirement -->
        <!-- <button class="tab-button reminders" [class.active]="activeTab === 'recordatorios'"
          (click)="setActiveTab('recordatorios')">
          Recordatorios
        </button> -->
      </div>

      <div class="dropdown-content" #scrollContainer (scroll)="onScroll($event)">
        <div class="notifications-list" *ngIf="(notifications$ | async) as notifications">
          <!-- Pinned Section -->
          <ng-container *ngIf="pinnedNotifications.length > 0">
            <div class="section-header pinned-section-header">
              <svg class="section-icon rotated" width="16" height="16" viewBox="0 0 24 24" fill="currentColor"
                xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                <path d="M16 12V4H17V2H7V4H8V12L6 14V16H11.2V22H12.8V16H18V14L16 12Z" />
              </svg>
              <span>{{ 'notifications.pinnedSection' | translate }}</span>
            </div>
            <div *ngFor="let notification of pinnedNotifications; trackBy: trackByNotificationId"
              class="notification-item pinned" [class.unread]="!notification.isRead"
              (click)="openNotificationDetail(notification)" (keydown.enter)="openNotificationDetail(notification)"
              [attr.tabindex]="0" role="button"
              [attr.aria-label]="notification.title + '. ' + (notification.isRead ? ('notifications.status.read' | translate) : ('notifications.status.unread' | translate))">
              <div class="notification-status" *ngIf="!notification.isRead" aria-hidden="true"></div>
              <div class="notification-info">
                <h4 class="notification-title">{{ notification.title }}</h4>
                <p class="notification-description" *ngIf="notification.message">
                  {{ notification.message }}
                </p>
                <span class="notification-time">{{ getRelativeTime(notification.createdAt) }}</span>
              </div>
              <div class="notification-actions">
                <app-notification-actions-buttons [notification]="notification" type="pinned"
                  (createTask)="openCreateTask($event.notification, $event.event)"
                  (togglePin)="togglePin($event.notification, $event.event)"
                  (markAsRead)="markAsRead($event.notification, $event.event)"
                  (markAsUnread)="markAsUnread($event.notification, $event.event)">
                </app-notification-actions-buttons>
              </div>
            </div>
          </ng-container>

          <!-- Active Notifications Section -->
          <ng-container *ngIf="activeNotifications.length > 0">
            <div *ngFor="let notification of activeNotifications; trackBy: trackByNotificationId"
              class="notification-item" [class.unread]="!notification.isRead"
              (click)="openNotificationDetail(notification)" (keydown.enter)="openNotificationDetail(notification)"
              [attr.tabindex]="0" role="button"
              [attr.aria-label]="notification.title + '. ' + (notification.isRead ? ('notifications.status.read' | translate) : ('notifications.status.unread' | translate))">
              <div class="notification-status" *ngIf="!notification.isRead" aria-hidden="true"></div>
              <div class="notification-info">
                <h4 class="notification-title">{{ notification.title }}</h4>
                <p class="notification-description" *ngIf="notification.message">
                  {{ notification.message }}
                </p>
                <span class="notification-time">{{ getRelativeTime(notification.createdAt) }}</span>
              </div>
              <div class="notification-actions">
                <app-notification-actions-buttons [notification]="notification" type="active"
                  (createTask)="openCreateTask($event.notification, $event.event)"
                  (togglePin)="togglePin($event.notification, $event.event)"
                  (markAsRead)="markAsRead($event.notification, $event.event)"
                  (markAsUnread)="markAsUnread($event.notification, $event.event)"
                  (postpone)="postponeNotification($event.notification, $event.days)">
                </app-notification-actions-buttons>
              </div>
            </div>
          </ng-container>

          <!-- Postponed Section -->
          <ng-container *ngIf="postponedNotifications.length > 0">
            <div class="section-header postponed-section-header">
              <svg class="section-icon" width="16" height="16" viewBox="0 0 24 24" fill="currentColor"
                xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                <path
                  d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67V7z" />
              </svg>
              <span>{{ 'notifications.postpone.section' | translate }}</span>
              <span class="postponed-count">({{ postponedNotifications.length }})</span>
            </div>
            <div *ngFor="let notification of postponedNotifications; trackBy: trackByNotificationId"
              class="notification-item postponed" (click)="openNotificationDetail(notification)"
              (keydown.enter)="openNotificationDetail(notification)" [attr.tabindex]="0" role="button"
              [attr.aria-label]="notification.title">
              <div class="notification-info">
                <h4 class="notification-title">{{ notification.title }}</h4>
                <p class="notification-description" *ngIf="notification.message">
                  {{ notification.message }}
                </p>
                <span class="notification-countdown">{{ notification.postponedUntil | timeUntil }}</span>
              </div>
              <div class="notification-actions">
                <app-notification-actions-buttons [notification]="notification" type="postponed"
                  (cancelPostpone)="cancelPostponement($event.notification, $event.event)"
                  (createTask)="openCreateTask($event.notification, $event.event)"
                  (markAsRead)="markAsRead($event.notification, $event.event)"
                  (markAsUnread)="markAsUnread($event.notification, $event.event)">
                </app-notification-actions-buttons>
              </div>
            </div>
          </ng-container>

          <!-- Other Notifications Section -->
          <ng-container *ngIf="unpinnedNotifications.length > 0">
            <div class="section-header" *ngIf="pinnedNotifications.length > 0">
              <span>{{ 'notifications.otherSection' | translate }}</span>
            </div>
            <div *ngFor="let notification of unpinnedNotifications; trackBy: trackByNotificationId"
              class="notification-item" [class.unread]="!notification.isRead"
              (click)="openNotificationDetail(notification)" (keydown.enter)="openNotificationDetail(notification)"
              [attr.tabindex]="0" role="button"
              [attr.aria-label]="notification.title + '. ' + (notification.isRead ? ('notifications.status.read' | translate) : ('notifications.status.unread' | translate))">
              <div class="notification-status" *ngIf="!notification.isRead" aria-hidden="true"></div>
              <div class="notification-info">
                <h4 class="notification-title">{{ notification.title }}</h4>
                <p class="notification-description" *ngIf="notification.message">
                  {{ notification.message }}
                </p>
                <span class="notification-time">{{ getRelativeTime(notification.createdAt) }}</span>
              </div>
              <div class="notification-actions">
                <app-notification-actions-buttons [notification]="notification" type="other"
                  (createTask)="openCreateTask($event.notification, $event.event)"
                  (togglePin)="togglePin($event.notification, $event.event)"
                  (markAsRead)="markAsRead($event.notification, $event.event)"
                  (markAsUnread)="markAsUnread($event.notification, $event.event)"
                  (postpone)="postponeNotification($event.notification, $event.days)">
                </app-notification-actions-buttons>
              </div>
            </div>
          </ng-container>

          <div *ngIf="isLoadingMore" class="loading-more" aria-live="polite">
            <span class="spinner"></span>
            <span>{{ 'notifications.loadingMore' | translate }}</span>
          </div>

          <div *ngIf="notifications.length === 0 && !isLoadingMore" class="empty-state">
            <p>{{ 'notifications.empty.title' | translate }}</p>
          </div>
        </div>
      </div>

      <div class="dropdown-footer">
        <button class="view-all-button" (click)="viewAll()">
          {{ 'notifications.viewAll' | translate }}
        </button>
      </div>
    </div>
  </mat-menu>
</div>